"use strict"
const Transform = require('stream').Transform
const inherits = require('util').inherits

const defaultEquals = function (a, b) {
  return a === b
}

const dontSkipDuplicates = function () { return false }

function PropertyStream (initialValue, options) {
  if (!(this instanceof PropertyStream)) {
    return new PropertyStream(initialValue, options)
  }
  Transform.call(this, {objectMode: true})
  options = options || {}

  this.currentValue = (initialValue != null) ? initialValue : null

  //by default, skip duplicate values using === as the equality check
  if (options.skipDuplicates === false) {
    this.valueEquals = dontSkipDuplicates
  } else if (options.equals) {
    this.valueEquals = options.equals
  } else {
    this.valueEquals = defaultEquals
  }

  //don't buffer values , if no other stream is listening, the currentValue will be updated
  //and the property will be written to any streams that pipe from this one later
  this.resume()
}
inherits(PropertyStream, Transform)

const proto = PropertyStream.prototype

proto._transform = function (data, enc, next) {
  if (this.currentValue != null && this.valueEquals(this.currentValue, data)) {
    return next(null)
  }
  this.currentValue = data
  next(null, data)
  this.resume()
}

//right now the property is only automatically passed along if using the pipe function
//if you subscribe to data using the .on('data', function (data) {}) event emitter way, you will have to
//also read the currentValue manually
proto.pipe = function (dst) {
  if (this.currentValue != null) {
    dst.write(this.currentValue)
  }
  return Transform.prototype.pipe.apply(this, arguments)
}

module.exports = PropertyStream
